import HeroSection from './sections/HeroSection';
import BeddingSection from './sections/BeddingSection';
import BathSection from './sections/BathSection';
import FragranceSection from './sections/FragranceSection';
import SeoCopySection from './sections/SeoCopySection';

const Home = () => (
  <div id="home">
    <HeroSection />
    <BeddingSection />
    <BathSection />
    <FragranceSection />
    <SeoCopySection />
  </div>
);

export default Home;
